var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNoti = function SvgNoti(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.018 3.16748C7.98388 3.16748 5.51805 5.63331 5.51805 8.66748V11.3166C5.51805 11.8758 5.27971 12.7283 4.99555 13.205L3.94138 14.9558C3.29055 16.0375 3.73971 17.2383 4.93138 17.6416C8.88221 18.9616 13.1447 18.9616 17.0955 17.6416C18.2047 17.275 18.6905 15.9641 18.0855 14.9558L17.0314 13.205C16.7564 12.7283 16.518 11.8758 16.518 11.3166V8.66748C16.518 5.64248 14.043 3.16748 11.018 3.16748Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 3.43332C11.6054 3.11761 10.4308 3.11761 9.32227 3.43332C9.5881 2.75499 10.2481 2.27832 11.0181 2.27832C11.7881 2.27832 12.4481 2.75499 12.7139 3.43332Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7686 17.9717C13.7686 19.4842 12.5311 20.7217 11.0186 20.7217C10.2669 20.7217 9.57022 20.41 9.07522 19.915C8.5602 19.3992 8.2702 18.7006 8.26855 17.9717",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noti.74b58bea.svg";
export { ForwardRef as ReactComponent };